export default "__VITE_ASSET__L1tOQcto__"